import styled from "styled-components";


export const StyledFormError = styled.span`

    font-size: 0.8rem;
    margin-top: 10px;
    color: var(--color-negative);
`